import type { Artifact } from "@lumen/shared";
import { t } from "../../i18n";
import { ConversationArtifactsList } from "../artifacts/ConversationArtifactsList";

/**
 * Side panel tab: every artifact present in this conversation. The tab itself
 * is only offered when the list is non-empty, so this view always has content.
 */
export function ChatArtifactsTab({
  artifacts,
  loading,
  error,
  reload,
}: {
  artifacts: Artifact[] | null;
  loading: boolean;
  error: string;
  reload: () => void;
}) {
  return (
    <ConversationArtifactsList
      artifacts={artifacts}
      loading={loading}
      error={error}
      onReload={reload}
      emptyMessage={t("No artifacts in this conversation yet.")}
    />
  );
}
